import { createApi } from '@reduxjs/toolkit/query/react';

import { apiSahBudgetPrintToSignRecords } from '~constants/api';

import { Paginated, PaginatedRequest, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { BudgetPrintToSignRecord } from '~support-at-home/models/budgetPrintToSignRecords';

export const budgetPrintToSignRecordsApi = createApi({
  reducerPath: 'budgetPrintToSignRecordsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahBudgetPrintToSignRecords }),
  tagTypes: ['budgetPrintToSignRecords'],
  endpoints: (builder) => ({
    getBudgetPrintToSignRecords: builder.query<Paginated<BudgetPrintToSignRecord>, PaginatedRequest>({
      query: (params) => ({
        url: '',
        method: 'GET',
        params,
      }),
      providesTags: [{ type: 'budgetPrintToSignRecords', id: 'LIST' }],
      transformResponse: (payload) => unwrap<Paginated<BudgetPrintToSignRecord>>(payload),
    }),
  }),
});

export const { useGetBudgetPrintToSignRecordsQuery } = budgetPrintToSignRecordsApi;
